module.exports = __webpack_public_path__ + "img/color_cn.2ce11fc.jpg";